import React, { useState } from 'react';
import { Footer } from '../common';
import { RadioGroup } from '../../../../../UiKit';
import styled from 'styled-components';
import { CancellationWarning } from './CancellationWarning';

export const GroupedReasons = ({
  reasons = null,
  // selectedGroupedReason = () => {},
  getIssuesInfo = () => {},
  cancellationWarning = null,
}) => {
  const [isEnabled, setEnabled] = useState(false);
  const [selectedReason, setSelectedReason] = useState(null);

  const selectOption = (id, selectedOption) => {
    const groupedReason = {};
    setEnabled(true);
    groupedReason['title'] = selectedOption.text;
    groupedReason['id'] = selectedOption.value;
    groupedReason['type'] = selectedOption.type;
    setSelectedReason(groupedReason);
  };

  const getReasons = () => {
    if (!reasons) return null;
    const items = [];
    reasons &&
      reasons.map((reason) => {
        const item = {};
        item['text'] = reason.title;
        item['type'] = reason.type;
        item['value'] = reason.id;
        items.push(item);
        return true;
      });
    return items;
  };

  const getReasonIdInfo = (event) => {
    if (!isEnabled) {
      event.preventDefault();
      return;
    }
    return getIssuesInfo(selectedReason);
  };

  const btnBgColor = isEnabled ? '#4B9B42' : '#B5B5B5';

  return (
    <>
      <GroupedReasons.Wrapper>
        <GroupedReasons.Content className='raiseIssueContent'>
          <RadioGroup items={getReasons()} selectOption={selectOption} />
          <CancellationWarning warning={cancellationWarning} />
        </GroupedReasons.Content>
      </GroupedReasons.Wrapper>{' '}
      <Footer
        submitBtnTitle='Next'
        btnBgColor={btnBgColor}
        sendFormData={getReasonIdInfo}
      />
    </>
  );
};

GroupedReasons.Wrapper = styled.div`
  flex-direction: column;
  position: relative;
  height: 100%;
  margin: 2rem;
  overflow: auto;
`;

GroupedReasons.Content = styled.div`
  flex-direction: column;
  padding-bottom: 18rem;
`;
